.av{flex-shrink:0;}